
import './style.scss';

import { Box, Drawer, IconButton } from '@mui/material';
import NavigationData from '../../data/Navigation';
import Category from './Category';
import { INavigationCategory, INavigationLink } from '../../interfaces/INavigation';
import { useState, useCallback } from 'react';
import useForceRender from '../../hooks/useForceRender';
import { useUserContext } from '../../contexts/UserContext';
import { MenuOpen } from '@mui/icons-material';


interface INavigationProps {
    open: boolean;
    handleClose: () => void;
}


const Navigation: React.FC<INavigationProps> = ({
    open,
    handleClose
}) => {
    const { user } = useUserContext();
    const forceRender = useForceRender();

    const [expandedLinks, setExpandedLinks] = useState<INavigationLink[]>([]);


    const handleChangeExpandedLinks = useCallback((navigationLink: INavigationLink) => {
        let expandedLinksAux = expandedLinks;

        if (expandedLinksAux.find(x => x.alias === navigationLink.alias)) {
            expandedLinksAux = expandedLinksAux.filter(x => x.alias !== navigationLink.alias);
        } else {
            expandedLinksAux.push(navigationLink);
        }

        setExpandedLinks(expandedLinksAux);
        forceRender();

        // eslint-disable-next-line
    }, [expandedLinks]);


    return (
        <>
            <Drawer
                anchor='left'
                open={open}
                onClose={handleClose}
                PaperProps={{
                    className: 'navigation-admin'
                }}
            >
                <Box className='box-images'>
                    <IconButton size="medium" className='iconbutton-closenavigation' onClick={handleClose}>
                        <MenuOpen fontSize='medium' />
                    </IconButton>
                </Box>

                <Box component='div' className='box-links'>
                    {
                        user && NavigationData.map((category: INavigationCategory) => {
                            return (
                                <Category
                                    title={category.title}
                                    aliasList={category.alias}
                                    items={category.items}

                                    expandedLinks={expandedLinks}
                                    handleChangeExpandedLinks={handleChangeExpandedLinks}
                                    handleCloseNavigation={handleClose}
                                    key={`navigationcategory-${category.alias}`}
                                />
                            );
                        })
                    }
                </Box>
            </Drawer>
        </>
    );
}


export default Navigation;